import React from 'react';
import * as navigator from '../../../native/navigator';
import {parseQuery} from '../../../utils/url';
import Detector from '../../../utils/detector';
import {downloadTanTuTravel} from '../../../config';

import './index.css';

const query = parseQuery();


function shouldShowTips() {
  return ['weixin', 'weixinwork', 'qq', 'uc', 'weibo'].indexOf(Detector.browser.name) !== -1;
}


export default class GuideBar extends React.Component {
  state = {
    showCover: true,
    showBrowserTips: false
  };

  hideCover = () => {
    this.setState({showCover: false});
  };

  hideBrowserTips = () => {
    this.setState({
      showBrowserTips: false
    });
  };

  showBrowserTips = () => {
    this.setState({
      showBrowserTips:true,
      showCover: false
    });
  };

  download = () => {
    navigator.push('http://uri6.com/tkio/QFRBRna');
  };

  invokeApp = () => {
    // 微信下 安卓及ios9以下 显示浏览器打开遮罩
    if (shouldShowTips()) {
      this.showBrowserTips();
    } else {
      // navigator.invoke(`/m/v2/?m=render2&page=trip#trip_id=${query.trip_id}`);
      navigator.tanTuMap();
    }
  };

  render() {

    return (
      <div className='guide-bar'>
        <div><h2 className='tantumap'>logo</h2></div>
        <div>
          <button className='download' onClick={this.download}>
            下载APP
          </button>
          {/* <button className='invoke' onClick={this.invokeApp}>
            打开
          </button> */}
        </div>

        {this.renderCover()}
        {this.renderBrowserTrips()}
      </div>
    );
  }

  renderCover() {
    let {showCover} = this.state;

    if (!showCover) return null;

    return (
      <div className='cover-layer'>
        <div className='pic'></div>
        <div className='text'>
          <h4>已将行程复制到账号：</h4>
          <h4>{query.account}</h4>
          <p>后续可在APP上登录帐号查看行程</p>
          <button onClick={this.hideCover}>我知道了</button>
        </div>
      </div>
    );
  }

  renderBrowserTrips() {
    let {showBrowserTips} = this.state;

    if (!showBrowserTips) return null;

    return (
      <div className='cover-layer open-in-browser'>
        <div className='pic'></div>
        <div className='text'>
          <h4>链接打不开？</h4>
          <p>点击右上角菜单，在默认浏览器中打开</p>
          <button onClick={this.hideBrowserTips}>我知道了</button>
        </div>
      </div>
    );
  }

}




// WEBPACK FOOTER //
// ./src/pages/trip/GuideBar/index.js